import createIcon from '../../createIcon';

/**
 * @component @name CameraIndoor
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTIgM0w0IDlWMjFIMjBWOUwxMiAzWk0xNiAxNi4wNkwxNCAxNVYxNkMxNCAxNi41NSAxMy41NSAxNyAxMyAxN0g5QzguNDUgMTcgOCAxNi41NSA4IDE2VjEyQzggMTEuNDUgOC40NSAxMSA5IDExSDEzQzEzLjU1IDExIDE0IDExLjQ1IDE0IDEyVjEzTDE2IDExLjk0VjE2LjA2WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const CameraIndoor = createIcon('CameraIndoor', [
  [
    'path',
    {
      d: 'M12 3L4 9V21H20V9L12 3ZM16 16.06L14 15V16C14 16.55 13.55 17 13 17H9C8.45 17 8 16.55 8 16V12C8 11.45 8.45 11 9 11H13C13.55 11 14 11.45 14 12V13L16 11.94V16.06Z',
      key: '1qbggc',
    },
  ],
]);

export default CameraIndoor;
